import type { ReactNode } from 'react'
import { NotFoundView } from '#src/components/NotFoundView.js'
import { getSeoData } from '#src/data/data.js'
import { languageService } from '#src/languageService.js'
import { getPosition } from '#src/pages/careers/careersPageData.js'
import PositionPage from '#src/pages/careers/position/PositionPage.js'
import { mergeMeta, noindexUnlessTranslated, seoTagsToMeta } from '#src/seo.js'
import type { Route } from './+types/position.route.js'

export async function loader({ request, params }: Route.LoaderArgs) {
  const { positionSlug } = params
  const lang = languageService.langFromRequest(request)
  const [data, seoData] = await Promise.all([
    getPosition(positionSlug, lang),
    getSeoData('position', lang, `{slug: {eq: "${positionSlug}"}}`),
  ])

  const meta = [
    ...seoTagsToMeta(seoData.page?.seo),
    ...noindexUnlessTranslated(`/careers/${positionSlug}`, lang),
  ]
  return { data, meta }
}

export function meta({ loaderData, matches }: Route.MetaArgs): Route.MetaDescriptors {
  return mergeMeta(matches[0].meta, loaderData?.meta || [])
}

export default function Position({ loaderData }: Route.ComponentProps): ReactNode {
  if (!loaderData.data) {
    return <NotFoundView />
  }

  return <PositionPage data={loaderData.data} />
}
